import type { RouteRecordRaw } from "vue-router"
import { routePaths } from "../routePaths"
import {
  CX_CORE_FEATURES_ENUM,
  DGK_FEATURES_ENUM,
  DIGITAL_TWIN_FEATURES_ENUM
} from "@/common/util/featuresUtil"
import { guardedImport } from "@/router/guardedImport"

const providerRoutes: RouteRecordRaw[] = [
  {
    path: "/provider",
    name: "provider",
    component: () => import("@/layout/AbstractRouteView.vue"),
    meta: {
      isProtected: true
    },
    children: [
      {
        path: routePaths.provider.assets.path,
        name: routePaths.provider.assets.pathName,
        component: guardedImport(
          DGK_FEATURES_ENUM.ASSETS,
          () => import("@/modules/provide/assets-overview/pages/AssetsPage.vue")
        ),
        meta: {
          isProtected: true,
          navigation: [
            {
              title: "Provide",
              translationKey: "sideMenu.provide"
            },
            {
              title: "Assets",
              translationKey: "sideMenu.assets",
              routeName: ""
            }
          ]
        }
      },
      {
        path: routePaths.provider.configure.path,
        name: routePaths.provider.configure.pathName,
        component: guardedImport(
          DIGITAL_TWIN_FEATURES_ENUM.CSV_FILE_UPLOAD,
          () => import("@/modules/provide/create-offer/pages/ConfigureOffer.vue")
        ),
        meta: {
          isProtected: true,
          navigation: [
            {
              title: "Provide",
              translationKey: "sideMenu.provide"
            },
            {
              title: "Provide data",
              translationKey: "sideMenu.publishData",
              routeName: ""
            }
          ]
        }
      },
      {
        path: routePaths.provider.uploadHistory.path,
        name: routePaths.provider.uploadHistory.pathName,
        component: () => import("@/modules/provide/upload-history/pages/UploadHistory.vue"),
        meta: {
          isProtected: true,
          navigation: [
            {
              title: "Provide",
              translationKey: "sideMenu.provide"
            },
            {
              title: "Asset upload history",
              translationKey: "sideMenu.uploadHistory",
              routeName: ""
            }
          ]
        }
      },
      {
        path: routePaths.provider.digitalTwin.path,
        name: routePaths.provider.digitalTwin.pathName,
        component: guardedImport(
          DIGITAL_TWIN_FEATURES_ENUM.BROWSE,
          () => import("@/modules/provide/digital-twin-browser/pages/DigitalTwinBrowser.vue")
        ),
        meta: {
          isProtected: true,
          navigation: [
            {
              title: "Provide",
              translationKey: "sideMenu.provide"
            },
            {
              title: "Digital Twin Browser",
              translationKey: "sideMenu.digitalTwin",
              routeName: ""
            }
          ]
        }
      },
      {
        path: routePaths.provider.messagesBrowser.path,
        name: routePaths.provider.messagesBrowser.pathName,
        component: guardedImport(
          CX_CORE_FEATURES_ENUM.MESSAGING,
          () => import("@/modules/provide/messages-browser/pages/MessagesBrowserProvide.vue")
        ),
        meta: {
          isProtected: true,
          navigation: [
            {
              title: "Provide",
              translationKey: "sideMenu.provide"
            },
            {
              title: "Messages Browser",
              translationKey: "sideMenu.messagesBrowserOutbound",
              routeName: ""
            }
          ]
        }
      }
    ]
  }
]

export default providerRoutes
